var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgEmptyCart = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 114,
  height: 114,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 114,
  height: 114,
  rx: 57,
  fill: "#F1F1F1"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M28.125 28.125v4.44h8.81c.947 0 1.756.624 2.065 1.526l4.113 36.99c.379 3.348 3.235 5.915 6.574 5.915h26.896v-4.44H49.687a2.178 2.178 0 0 1-2.186-1.96l-.275-2.48H75.17c3.132 0 5.868-2.254 6.488-5.341l4.216-21.296H44.249l-.947-8.463-.068-.209a6.622 6.622 0 0 0-6.299-4.682h-8.81Zm44.052 48.87c-2.426 0-4.405 1.995-4.405 4.44 0 2.445 1.979 4.44 4.405 4.44 2.427 0 4.406-1.995 4.406-4.44 0-2.445-1.98-4.44-4.406-4.44Zm-22.026 0c-2.426 0-4.405 1.995-4.405 4.44 0 2.445 1.979 4.44 4.405 4.44s4.405-1.995 4.405-4.44c0-2.445-1.978-4.44-4.405-4.44Zm-5.403-31.077h35.758L77.34 61.891c-.224 1.057-1.102 1.786-2.169 1.786H46.727l-1.98-17.759Z",
  fill: "#DC632A"
})));
export default SvgEmptyCart;